import * as constants from '../../constants';
import * as actionTypes from '../actions/actionTypes';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  departmentOfRealEstate: null,
  departmentOfRealEstates: null,
  departmentOfRealEstatesAll: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const departmentOfRealEstateReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.DEPARTMENTOFREALESTATE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.DEPARTMENTOFREALESTATE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.DEPARTMENTOFREALESTATE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default departmentOfRealEstateReducer;
